<template>
	<div class="module_page page_content tag_type_creation" aria-label="Create Tag Type">

    	<div class="row page-heading">
            <div class="col-8 input module_heading" role="heading" aria-level="1">
                    <span class="module_icon ic-tag"></span>
                <!--<label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}<span class="ml-3">></span><span class="ml-3">Tag Types</span></label>-->
                <label class="head_txt module_type_name institution-title ace_sec_hd">
                    <span class="ml-3">Tag Configuration</span><span class="ml-3">></span><span class="ml-3">Tag Type</span><span class="ml-3">></span>
                    <template v-if="data && data.displayValue">
                        <span class="ml-3">{{data.displayValue}}</span>
                    </template>
                    <template v-else>
                        <span class="ml-3">New</span>
                    </template>
                </label>
            </div>
            <div class="col-4 btn_container">
				<button class="btn btn-primary" @click="saveOrDone(true)" aria-label="done">done</button>
                <button class="btn btn-primary" @click="saveOrDone(false)" aria-label="save">save</button>
                <button class="btn-cancel" @click="cancel" aria-label="cancel"><span class="icon-cross"></span></button>
            </div>
        </div>


    	<div class="page-content">

			<div class="col-12 dasboard-left-section">
	    		<div class="row">
	        		<div class="col-12 pg_fld_sec">


						<div class="row pg_fld_row">
		      				<div class="col-xl-2 col-lg-2 col-md-3 col-sm-12 fld_label label_1">
		      					<label class="label" id="tagType">Tag Type</label>
		      					<span class="fld_req">*</span>
		      				</div>
		      				<div class="col-xl-10 col-lg-10 col-md-9 col-sm-12 fld_input">
		      					<b-form-group :state="tagTypeState" invalid-feedback="Tag Type must not be empty">
                        			<b-form-input
                          				v-model="tagType"
                          				:state="tagTypeState"
                          				@blur="$v.tagType.$touch()"
                          				placeholder="Type Tag Type"
                          				:disabled="isTagTypeCreated"
                          				v-focus>
                          			</b-form-input>
                    			</b-form-group>
		      				</div>
			      		</div>


			      		<div class="row pg_fld_row">
		      				<div class="col-xl-2 col-lg-2 col-md-3 col-sm-12 fld_label label_1">
		      					<label class="label" id="tags">Tags</label>
		      				</div>
		      				<div class="col-xl-10 col-lg-10 col-md-9 col-sm-12 fld_input">

		      					<div class="tags_section">
		      						<div class="tags_container">
			                            <span class="tag" v-for="(data, index) in tagSetting.adminDefined" v-bind:title="data.tag.name" v-bind:aria-label="data.tag.name">
			                                <span class="tag_name"> {{ data.tag.name }} </span>
			                                <span class="action">
			                                    <span class="edit icon-edit" @click="openEditTag(data.tag.name, index)" :id="`editTag_${index}`" title="edit tag"></span>
			                                    <template v-if="uuid">
    			                                    <span class="delete-icon" @click="showDeleteTagConfirm(tagSetting.category, data.tag.name, index)" title="delete tag">
    			                                        <i class="icon-bin" aria-hidden="true"></i>
    			                                    </span>
			                                    </template>
			                                    <template v-else>
    			                                    <span class="delete-icon" @click="removeTag(index)" title="delete tag">
    			                                        <i class="icon-bin" aria-hidden="true"></i>
    			                                    </span>
			                                    </template>

			                                    <b-popover :ref="`editTagPopover_${index}`" :target="`editTag_${index}`" triggers="click" @shown="onShownEditTag">

				                                        <template slot="title">
				                                        	<span class="title">Edit Tag</span>
				                                            <button class="btn_close" aria-label="close" @click="onCloseEditTag(index)">
                                                                <span class="ic-close"></span>
                                                            </button>
				                                        </template>

														<div class="edit_tag_popup">
					                                        <div @keydown.enter="editTag">
					                                            <b-form-group
					                                              :state="tagState"
					                                              class="mb-1"
					                                              :invalid-feedback="invalidFeedback">
					                                              <b-form-input
					                                                :ref="`tagName_${index}`"
					                                                id="tag-name"
					                                                v-model.trim="tagName"
					                                                :state="tagState"
					                                                size="sm"
					                                                placeholder="Type Tag Name"
					                                                @input="forceLowerCase($event, 'tagName')"
					                                              ></b-form-input>
					                                            </b-form-group>
					                                        </div>
				                                        </div>

														<div class="modal-footer">
			                                        		<b-button @click="editTag" size="sm" variant="primary">ok</b-button>
			                                        	</div>

			                                    </b-popover>

			                                </span>
			                            </span>
		                            </div>
		                            <div class="btn_container">
		                                <button type="button" class="btn btn-primary" aria-label="new" id="addTag">new</button>
		                            </div>
		                        </div> <!-- .tag-section -->

		      				</div>
			      		</div>


			      		<div class="row pg_fld_row">
		      				<div class="col-xl-2 col-lg-2 col-md-3 col-sm-12 fld_label">
		      					<label class="label" id="setting">Settings</label>
		      				</div>
		      				<div class="col-xl-10 col-lg-10 col-md-9 col-sm-12 fld_input">
		      					<span class="mr-3">Exposed to User</span>
                    			<span>
                        			<toggle-button :value="isExposedToUser" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :width="60" :height="25" :font-size="15" color="#0A7714" @change="toggleExposedToUser" />
                    			</span>
		      				</div>
			      		</div>


			      		<div class="row pg_fld_row">
		      				<div class="col-xl-2 col-lg-2 col-md-3 col-sm-12 fld_label">
		      					<label class="label">Tag Granularity</label>
		      				</div>
		      				<div class="col-xl-10 col-lg-10 col-md-9 col-sm-12 fld_input">
		      					<div class="pg_fld_inner_hd">
									<input type="checkbox" @click="selectAllTagGranularityOption" v-model="tagGranularityOptionAllSelected"/> Select All
                        		</div>
                        		<div class="row checkbox_row">
	                    			<div v-for="option in tagGranularityOptions" class="col-xl-3 col-lg-4 col-md-5 col-sm-6 checkbox_fld">
			                        	<input type="checkbox" v-model="tagGranularityOptionSelected" :value="option.value" :label="option.text" :state="tagGranularityOptionSelectDeselect"/>
			                            <label>{{option.text}}</label>
			                        </div>
		                        </div>
		      				</div>
			      		</div>


	        		</div> <!-- .pg_fld_sec -->
	        	</div> <!-- .row -->
			</div> <!-- .dasboard-left-section -->

		</div> <!-- .page-content -->


        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                </div>
            </b-modal>
        </div>

        <div>
            <b-modal class="delete-folder-popup" ref="deleteTagConfirmModal" no-close-on-backdrop no-close-on-esc centered>
                <div style="text-align: center;">
                    <h6 v-html="deleteTagMessage"></h6>
                </div>
                <div slot="modal-header" class="popover-header">
                    <div class="popup-heading">Deleting Tag</div>
                    <button class="btn_close" aria-label="close" @click="cancelDelete">
                        <span class="ic-close"></span>
                      </button>
                </div>
                <div slot="modal-footer" class="w-100">
                    <b-button @click="deleteSelected" class="btn button-primary next float-right mr-2" aria-label="yes"> yes </b-button>
                    <b-button @click="cancelDelete" class="btn button-primary next float-right mr-2" aria-label="no"> no </b-button>
                </div>
            </b-modal>
        </div>


        <b-popover ref="addTagPopover" target="addTag" triggers="click" @show="onShow" @shown="onShown" :show.sync="showAddTagPopover">
            <template slot="title">
                <button class="btn_close" aria-label="close" @click="onClose">
                    <span class="ic-close"></span>
                </button>
                <span class="title">Add Tag</span>
            </template>

            <div @keydown.enter="addTag">
                <b-form-group
                  :state="tagState"
                  class="mb-1"
                  :invalid-feedback="invalidFeedback">
                  <b-form-input
                    ref="tagName"
                    id="tag-name"
                    v-model.trim="tagName"
                    :state="tagState"
                    size="sm"
                    placeholder="Type Tag Name"
                    @input="forceLowerCase($event, 'tagName')"
                  ></b-form-input>
                </b-form-group>
            </div>
            <div class="modal-footer">
             <b-button @click="addTag" size="sm" variant="primary">add</b-button>
           </div>
        </b-popover>

    </div>
</template>

<script>
    import Vue from 'vue'
    import { mapActions } from 'vuex'
    import Vuelidate from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'
    Vue.use(Vuelidate)
    Vue.directive('focus', {
      inserted (el) {
        el.focus()
      }
    })

    export default {
      name: 'create-tag-type',
      props: ['institutionId', 'existingTagCategories', 'uuid', 'data'],
      data: () => {
        return {
          tagName: '',
          tagState: null,
          tagType: '',
          tagTypeState: null,
          isExposedToUser: true,
          showAddTagPopover: false,
          isTagTypeCreated: false,
          tagGranularityOptionAllSelected: false,
          tagGranularityOptions: [
            {text: 'Course', value: 'course'},
            {text: 'Topic', value: 'topics'},
            {text: 'Asset', value: 'assets'},
            {text: 'Stream', value: 'stream'},
            {text: 'Catalog', value: 'catalog'},
            {text: 'Person', value: 'person'},
            {text: 'Job', value: 'job'},
            {text: 'Club', value: 'club'},
            {text: 'Event', value: 'event'}
          ],
          tagGranularityOptionSelected: ['course'],
          tagSetting: {
            category: null,
            displayValue: null,
            pragyaDefined: [],
            adminDefined: [],
            exposedToUser: {
              header: 'Tag exposed to user',
              options: ['yes', 'no'],
              optionType: 'radio',
              optionSelected: 'yes'
            },
            typesAllowed: {
              header: 'Type of Tags Allowed',
              options: ['pre-defined', 'user defined'],
              optionType: 'checkbox',
              optionSelected: ['pre-defined', 'user defined']
            },
            granularity: {
              header: 'Tag Granularity',
              options: ['Course', 'Topic', 'Asset', 'Stream'],
              optionType: 'checkbox',
              optionSelected: this.tagGranularityOptionSelected
            }
          },
          editIndex: -1,
          deleteIndex: -1,
          deleteTagMessage: '',
          deleteTagEntityCount: 0,
          matchAtLeastOneInTags: [],
          entityTypeAndUuidMapping: {},
          libraryList: localStorage.getItem('user_personal_LS_UUID'),
          indexList: ['deliverycontext', 'learningcontent', 'learningtopic', 'stream', 'job', 'catalog', 'event', 'club', 'person']
        }
      },

      validations: {
        tagName: {
          required
        },
        tagType: {
          required
        }
      },

      watch: {
        tagName (val) {
          if (val) {
            this.tagState = true
          }
        },

        tagType (val) {
          if (val) {
            this.tagTypeState = true
          }
        }
      },

      mounted () {
        if (this.uuid && this.data) {
          this.isTagTypeCreated = true
          this.tagType = this.data.displayValue
          this.tagSetting.uuid = this.uuid
          Object.assign(this.tagSetting, this.data)
          this.isExposedToUser = (this.data.exposedToUser.optionSelected === 'yes')
          this.tagGranularityOptionSelected = this.data.granularity.optionSelected
        }
      },

      computed: {
        invalidFeedback () {
          if (!this.tagName) {
            return 'This field is required'
          } else {
            let found = this.tagSetting.adminDefined.find((item, index) => {
              return (this.tagName === item.tag.name) && (this.editIndex !== index)
            })
            if (found) {
              this.tagState = false
              return 'Tag already exists'
            }
          }
        },

        tagGranularityOptionSelectDeselect () {
          if (this.tagGranularityOptions.length === this.tagGranularityOptionSelected.length) {
            this.tagGranularityOptionAllSelected = true
          } else {
            this.tagGranularityOptionAllSelected = false
          }
        }
      },

      methods: {
        ...mapActions([
          'saveTagSetting',
          'constructSearchQuery',
          'loadDeleteTagsFromEntity'
        ]),

        forceLowerCase (e, prop) {
          e = e.trim().toLowerCase()
          this.$set(this.$data, prop, e)
        },

        generateTagCategory () {
          let lowerTagType = this.tagType.toLowerCase()
          let found = this.validateTagCategory(lowerTagType)
          if (found) {
            let category = this.tagType.replace(/ /g, '')
            return category.substr(0, 1).toLowerCase() + category.substr(1)
          } else {
            let category = 'custom_'.concat(lowerTagType.replace(/ /g, '_1_').replace(/\./g, '_2_'))
            return category
          }
        },

        validateTagCategory (displayValue) {
          return this.existingTagCategories.find((item) => {
            return displayValue.toLowerCase() === item.displayValue
          })
        },

        toggleExposedToUser (ev) {
          this.isExposedToUser = ev.value
        },

        showLoader () {
          if (this.$refs.loadingModal) {
            this.$refs.loadingModal.show()
          }
        },

        hideLoader () {
          if (this.$refs.loadingModal) {
            this.$refs.loadingModal.hide()
          }
        },

        cancel () {
          return this.$router.push({name: 'tagList'})
        },

        selectAllTagGranularityOption () {
          if (this.tagGranularityOptionAllSelected) {
            this.tagGranularityOptionSelected = []
          } else {
            this.tagGranularityOptionSelected = []
            this.tagGranularityOptions.forEach((item) => {
              this.tagGranularityOptionSelected.push(item.value)
            })
          }
        },

        saveOrDone (isDone) {
          this.$v.tagType.$touch()
          if (!this.tagTypeState) {
            this.tagTypeState = false
          } else {
            let displayValue = this.tagType
            let found = this.validateTagCategory(displayValue)
            if (found && !this.tagSetting.uuid) {
              this.$notify({
                group: 'notify',
                type: 'error',
                title: '',
                text: 'Tag Type "' + displayValue + '" already exists. Please provide some other name.'
              })
            } else {
              this.showLoader()
              this.tagSetting.institutionUuid = this.institutionId
              this.tagSetting.granularity.optionSelected = this.tagGranularityOptionSelected
              this.tagSetting.exposedToUser.optionSelected = (this.isExposedToUser) ? 'yes' : 'no'
              let message = 'Tag Type "' + displayValue + '" created successfully.'
              if (this.tagSetting.uuid) {
                message = 'Tag Type "' + displayValue + '" updated successfully.'
              } else {
                let category = this.generateTagCategory()
                this.tagSetting.category = category
                this.tagSetting.displayValue = displayValue
              }
              this.saveTagSetting(this.tagSetting).then(res => {
                this.hideLoader()
                this.$notify({
                  group: 'notify',
                  type: 'success',
                  title: '',
                  text: message
                })
                if (isDone) {
                  this.cancel()
                } else {
                  this.isTagTypeCreated = true
                  this.tagSetting.uuid = res.uuid
                }
              })
            }
          }
        },

        addTag () {
          if (!this.tagName) {
            this.tagState = false
          }
          if (this.tagState) {
            let value = this.tagName.toLowerCase()
            let tag = {oldName: value, name: value, auto: false}
            let item = {tag: tag, visible: true}
            this.tagSetting.adminDefined.push(item)
            this.onShow()
          }
        },

        onClose () {
          this.showAddTagPopover = false
        },

        onShow () {
          this.tagName = ''
          this.tagState = null
        },

        onShown () {
          this.focusRef(this.$refs.tagName)
        },

        focusRef (ref) {
          this.$nextTick(() => {
            this.$nextTick(() => {
              (ref.$el || ref).focus()
            })
          })
        },

        openEditTag (value, index) {
          this.tagName = value
          this.editIndex = index
          let ref = 'editTagPopover_' + index
          this.$refs[ref][0].$emit('open')
        },

        onCloseEditTag (index) {
          this.tagName = ''
          this.editIndex = -1
          this.tagState = null
          let ref = 'editTagPopover_' + index
          this.$refs[ref][0].$emit('close')
        },

        onShownEditTag () {
          let ref = 'tagName_' + this.editIndex
          this.focusRef(this.$refs[ref][0])
        },

        editTag () {
          if (!this.tagName) {
            this.tagState = false
          }
          if (this.tagState) {
            let old = this.tagSetting.adminDefined[this.editIndex]
            let tag = {oldName: old.tag.name, name: this.tagName.toLowerCase(), auto: false}
            let item = {tag: tag, visible: true}
            this.tagSetting.adminDefined.splice(this.editIndex, 1, item)
            this.onCloseEditTag(this.editIndex)
          }
        },

        showDeleteTagConfirm (category, name, index) {
          this.showLoader()
          this.deleteIndex = index
          this.deleteTagEntityCount = 0
          this.deleteTagMessage = 'Do you want to delete this Tag?'
          this.matchAtLeastOneInTags = [{tagValue: name, category: category}]
          this.constructSearchQuery({terms: '', matchAtLeastOneInTags: this.matchAtLeastOneInTags, pageNumber: 1, from: 0, indexList: this.indexList, libraryList: this.libraryList}).then(res => {
            if (res && res.hits) {
              this.deleteTagEntityCount = res.hits.total
              if (this.deleteTagEntityCount > 0) {
                if (this.deleteTagEntityCount > 1) {
                  this.deleteTagMessage = 'There are ' + this.deleteTagEntityCount + ' entities associated with this Tag.<BR><BR>' + this.deleteTagMessage
                } else {
                  this.deleteTagMessage = 'There is 1 entity associated with this Tag.<BR><BR>' + this.deleteTagMessage
                }
              }
            }
            this.hideLoader()
            this.$refs.deleteTagConfirmModal.show()
            if (res && res.hits && res.hits.hits) {
              let results = res.hits.hits
              results.forEach(result => {
                let enityType = (result._index === 'stream') ? 'entity' : result._index
                let uuid = result._source.uuid
                if (this.entityTypeAndUuidMapping.hasOwnProperty(enityType)) {
                  this.entityTypeAndUuidMapping[enityType].push(uuid)
                } else {
                  this.entityTypeAndUuidMapping[enityType] = [uuid]
                }
              })
            }
          })
        },

        deleteSelected () {
          this.$refs.deleteTagConfirmModal.hide()
          this.tagSetting.adminDefined.splice(this.deleteIndex, 1)
          this.deleteIndex = -1
          let keys = Object.keys(this.entityTypeAndUuidMapping)
          if (keys.length > 0) {
            let count = 0
            let categoryToBeDeleted = this.matchAtLeastOneInTags[0]
            keys.forEach(entity => {
              let uuids = this.entityTypeAndUuidMapping[entity]
              let url = entity + '/deleteTagsFromEntity?uuids=' + uuids
              this.loadDeleteTagsFromEntity({url: url, categoryToBeDeleted: categoryToBeDeleted}).then(res => {
                count++
                if (keys.length === count) {
                  this.saveOrDone(false)
                }
              })
            })
          } else {
            this.saveOrDone(false)
          }
          this.resetSelectedTagsInTagType()
        },

        cancelDelete () {
          this.$refs.deleteTagConfirmModal.hide()
          this.deleteIndex = -1
          this.deleteTagEntityCount = 0
          this.resetSelectedTagsInTagType()
        },

        resetSelectedTagsInTagType () {
          this.deleteTagMessage = ''
          this.matchAtLeastOneInTags = []
          this.entityTypeAndUuidMapping = {}
          this.$store.commit('LOAD_MATCH_AT_LEAST_ONE', [])
        },

        removeTag (index) {
          this.tagSetting.adminDefined.splice(index, 1)
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/tagging/components/CreateTagType.vue